import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Header from './Components/Header'
import ArbitradeBot from './Pages/Account/ArbitradeBot'
import Dashboard from './Pages/Account/Dashboard'
import History from './Pages/Account/History'
import IncomeOverview from './Pages/Account/IncomeOverview'
import Subscriptions from './Pages/Account/Subscriptions';
import Withdrawal from './Pages/Report/Withdrawal'

import DirectMember from './Pages/Report/DirectMember';
import AllMember from './Pages/Report/AllMember';
import Income from './Pages/Report/Income';
import Support from './Pages/Report/Support'
import SubscriptionsDetails from './Pages/Report/SubscriptionsDetails'
import ChangePassword from './Pages/Account/ChangePassword'
import AirDrop from './Pages/Report/AirDrop'

// Auth guard that redirects to /login if there is no token
const ProtectedRoute = ({children}) => {
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return children ? children : <Outlet />;
};

const Route = [
    {
        path: 'user',
        element: (
            <ProtectedRoute>
                <Header />
            </ProtectedRoute>
        ),
        children: [
            {
                path: 'dashboard',
                element: <Dashboard />
            },
            {
                path: 'bot',
                element: <ArbitradeBot />
            },
            {
                path: 'subscriptions',
                element: <Subscriptions />
            },
            {
                path: 'overview',
                element: <IncomeOverview />
            },
            {
                path: 'support',
                element: <Support />
            },
            {
                path: 'subscriptionsdetails',
                element: <SubscriptionsDetails />
            },
            {
                path: 'history',
                element: <History />
            },
            {
                path: 'allmember',
                element: <AllMember />
            },
            {
                path: 'directmember',
                element: <DirectMember />
            },
            {
                path: 'income',
                element: <Income />
            },
            {
                path: 'account',
                element: <ChangePassword />
            },
            {
                path: 'withdrawal',
                element: <Withdrawal />
            },
            {
                path: 'airdrop',
                element: <AirDrop />
            },
            {
                path: '*',
                element: <>404</>
            }
        ]
    }
]
export default Route